<router-outlet></router-outlet>

<div class="toast-wrapper">
  <!-- Remarks: Register your new tost key here -->
  <!-- If you will try to put conditional statement, then it will arise an issue -->
  <!-- So, it is better to put the key directly, and it will trigger based on the your-->
  <app-confirmation-toast
    [key]="toastKeys.CONFIRM"
    [position]="toastConfig.position"
    [labelInfo]="toastConfig.labels"
    [styleClassName]="toastConfig.styleClassName"
    [autoCloseInfo]="toastConfig.autoClose"
    (onReject)="handleAction('reject', $event)"
    (onConfirm)="handleAction('accept', $event)"
    tabindex="0"
  />
  <p-toast
    [position]="toastConfig.position ?? 'top-right'"
    [key]="toastKeys.default"
  />
</div>
@if (!loaderService.isLoaderDisable && loading) {
  <div class="custom-loading-overlay">
    <i class="custom-loader"></i>
    @if (loaderMessage()?.length) {
      <span class="delay-message">{{ loaderMessage() }}</span>
    } @else if (showTimeoutMessage) {
      <span class="delay-message">
        Taking longer than expected,
        <br />
        please try again later
      </span>
    } @else {
      <span class="delay-message">Loading data, Please wait...</span>
    }
  </div>
}
